import { SelectOption } from '@components/common';

export const ROLE_OPTIONS: SelectOption<AccountRole>[] = [
  { value: 'admin', label: 'Admin only' },
  { value: 'creator', label: 'Admin & Creator only' }
];

export const COMPLIANCE_REGULATORS = ['SOC 2 Type II', 'SOC 2 Type I', 'GDPR', 'HIPAA'];

export const AUTH_METHOD_DISABLED_REASON =
  'This authentication method is currently in use for your account. In order to disable, you must be authenticated through a different method first.';

export const AUTH_METHOD_NAMES: Record<AuthMethod, string> = {
  password: 'Email & Password',
  google: 'Google SSO',
  saml: 'SAML',
  openid_connect: 'Open ID',
  openid_connect_intuit: 'Open ID'
};
